import classNames from "classnames";
import React, { FC, HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const Container: FC<
  HTMLAttributes<HTMLDivElement> & { children: ReactNode }
> = ({ children, className = "", ...props }) => {
  const classes = twMerge(
    classNames("px-4 md:px-8 mx-auto", {
      "py-24": !className.includes("py-"),
      "max-w-6xl":
        !className.includes("max-w") && !className.includes("w-full"),
    }),
    className
  );
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};
